import React from 'react';

enum EBadgeSize {
	small = 'w-3.5 h-3.6',
	large = 'w-[25px] h-[25px]',
	xLarge = 'w-[32px] h-[32px]',
}

type BadgeSize = keyof typeof EBadgeSize;

interface IBadgeProps {
	children?: React.ReactNode;
	className?: string;
	color?: 'gray' | 'yellow';
	size?: BadgeSize;
	onAnimationEnd?: () => void;
}

export const Badge = ({
	color = 'gray',
	className = '',
	children,
	size = 'small',
	onAnimationEnd = () => {},
}: IBadgeProps) => {
	return (
		<span
			className={`rounded text-gray-100 font-bold ${
				EBadgeSize[size]
			} inline-flex justify-center items-center w-3.5 h-3.5 ${
				color === 'gray' ? 'bg-gray-600' : 'bg-primary'
			} ${className}`}
			onAnimationEnd={onAnimationEnd}>
			{children}
		</span>
	);
};
